import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { addQuestion, getQuestionById } from '../../store/questionSlice';
import EditQuestionComponent from './EditQuestionComponent';
import { getBodmasTestQuestionsById } from '../../store/bodmasTestQuestionSlice';


const BodmasEditQuestionsTable = () => {


    const dispatch = useDispatch();
    const location = useLocation();
    const storeVar = useSelector(state => state.bodmasTestQuestion)
   

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get("id");
        dispatch(getBodmasTestQuestionsById(id));
    }, [dispatch, location]);

    if (storeVar.loading || !storeVar.bodmasTestQuestionsDetails || Object.keys(storeVar.bodmasTestQuestionsDetails).length === 0) {
        return <p>Loading...</p>;
    }

    return (

        < EditQuestionComponent props={storeVar.bodmasTestQuestionsDetails} />

    )
}

export default BodmasEditQuestionsTable